import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { SiteHttpService } from '@core/services/http';
import { ContactsPlace } from '@models/enums';
import { Contacts } from '@shared/components';
import { SiteActions } from '@store/actions';
import { SiteSelectors, UserSelectors } from '@store/selectors';

type SiteContactsProps = {
  isActive?: boolean;
};

export const SiteContacts: FC<SiteContactsProps> = ({
  isActive,
}: SiteContactsProps) => {
  const dispatch = useDispatch();
  const siteContacts = useSelector(SiteSelectors.getSiteContactsInfo);
  const currentSite = useSelector(SiteSelectors.getCurrentSite);
  const isLoading = useSelector(SiteSelectors.getTabLoadingState('contacts'));
  const isDataLoaded = useSelector(SiteSelectors.getTabLoadedState('contacts'));

  const { contactsAccess } = useSelector(
    UserSelectors.getSiteBrowsePermissions,
  );
  const locationCode =
    currentSite?.PSLocationCode ?? currentSite?.MDGLocationCode;

  useEffect(() => {
    if (isActive && locationCode && !isDataLoaded && !isLoading) {
      dispatch(
        SiteActions.setTabLoading.done({
          tabName: 'contacts',
          isLoading: true,
        }),
      );
      HttpService.getHttpRequests(SiteHttpService)
        .getSiteContacts(locationCode)
        .catch(() =>
          dispatch(
            SiteActions.setTabError.done({
              tabName: 'contacts',
              hasError: true,
            }),
          ),
        );
    }
  }, [dispatch, isActive, isDataLoaded, isLoading, locationCode]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-site-contacts loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="prov-site-contacts">
      <Contacts
        data={siteContacts}
        place={ContactsPlace.Site}
        editable={!!contactsAccess}
      />
    </div>
  );
};
